import { toast } from 'react-toastify'
import { NEWS, SALES } from '../constant/routes'

interface Types {
  url: string
  method: string
  token: string | null
  formData: FormData
  setIsFormLoading: (value: boolean) => void
  mutate: (value: string) => void
  destroyToken: () => void
  history: { push: (value: string) => void }
}

export const updateResource = async ({
  url,
  method,
  token,
  formData,
  setIsFormLoading,
  mutate,
  destroyToken,
  history,
}: Types) => {
  const resource = url.startsWith('news/article') ? 'Το Άρθρο' : 'Η προσφορά'

  try {
    const response = await fetch(`${process.env.REACT_APP_API_HOST}/api/${url}/`, {
      method,
      body: formData,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })

    if (response.ok) {
      toast.success(`${resource} ενημερώθηκε με επιτυχία.`)
      setIsFormLoading(false)
      mutate(url.startsWith('news/article') ? 'news/article' : 'offers/offer')
      history.push(url.startsWith('news/article') ? NEWS.main : SALES.main)
    }

    if (response.status === 401) {
      destroyToken()
      throw new Error('Η σύνδεση σας έχει λήξει. Παρακαλώ συνδεθείτε ξανά.')
    }

    if (!response.ok) {
      throw new Error(`Αποτυχία ενημέρωσης. Παρακαλώ δοκιμάστε ξανά.`)
    }
  } catch (err) {
    if (err instanceof Error) {
      toast.error(err.message)
    }
    setIsFormLoading(false)
  }
}
